import myFoodBenefit from './myFoodBenefit/myFoodBenefit';
import foodBenefitRouting from './foodBenefitRouting/foodBenefitRouting';
import foodBenefitManager from './foodBenefitManager/foodBenefitManager';
import foodBenefitDelegations from './foodBenefitDelegations/foodBenefitDelegations';
import foodBenefitWorkTeam from './foodBenefitWorkTeam/foodBenefitWorkTeam';

let foodBenefitFeatures = angular.module('food-benefit.features', [
  myFoodBenefit,
  foodBenefitRouting,
  foodBenefitManager,
  foodBenefitDelegations,
  foodBenefitWorkTeam,
])
  .name;

export default foodBenefitFeatures;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/food-benefit.features.js